var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcLoginBgLight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 863,
    viewBox: "0 0 1440 863",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19057_45813)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 862,
    transform: "translate(0 0.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1744.3 497.841C1742.16 496.551 1740.9 494.72 1738.48 493.605C1732.7 490.947 1721.89 489.257 1716.95 488.19C1687.39 481.802 1657.46 475.111 1627.24 472.829C1598.38 470.651 1570.42 474.468 1542.02 479.24C1494.7 487.195 1426.16 499.019 1381 516C1336.12 532.875 1313.06 549.931 1272.14 574.872C1236.8 596.41 1198.37 620.432 1178.1 656.66C1164.54 680.895 1156 719.503 1166.62 748.216C1175.64 772.631 1213.11 800.445 1235.66 797.49C1282.02 791.414 1302.72 748.053 1308.73 698.297C1315.37 643.25 1272.14 599.92 1230 587.47C1183.82 581.143 1179.37 577.954 1116.23 604.125C999.641 670.53 924.992 850.494 916.361 863.335M773.5 976.5C748.507 986.374 422.8 905.301 398.584 897.343",
    stroke: "black",
    strokeOpacity: 0.16,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "8 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-15.5503 500.299C69.8147 496.248 178.423 436.936 216.089 362.582C261.007 273.913 280.419 149.587 226.765 59.9734C216.148 42.2406 200.732 26.9113 178.803 25.5914C156.153 24.2283 138.376 38.3705 129.663 58.3249C116.71 87.9906 123.431 128.206 133.117 157.782C147.462 201.584 169.49 243.087 192.854 282.671C218.499 326.119 249.437 367.731 293.174 394.373C389.451 453.019 507.593 439.679 592.093 385.179C672.506 333.315 925.898 -5.00562 930.167 -20.5352",
    stroke: "black",
    strokeOpacity: 0.16,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "8 16"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19057_45813"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 862,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcLoginBgLight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icLoginBgLight.d2d8dd3a1d1e9146b052c8ff193d3ff7.svg";